import React from 'react'

function TenderTextSKSStatic() {
  return (
    <embed src="\pdfs\EAT2.1.2_SKS-5-3_Static_Cooling_System.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSKSStatic